import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { afterHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/after-hook.js'
import { beforeHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/before-hook.js'
import { lifecycleContext } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-context.js'
import { lifecycleHookImport } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-hook-import.js'
import { renderGenBulkSortOrderContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-bulk-sort-order-content.js'

export function genBulkSortOrderContent(ctx: EntityCtx): string {
  const reorderContext = lifecycleContext(ctx.plural, `,\n      changedFields: ['sortOrder']`)

  return renderGenBulkSortOrderContentServerActionTemplate({
    ctxTableVar: ctx.tableVar,
    ctxCacheInvalidationFn: ctx.cacheInvalidationFn,
    ctxCamelPlural: ctx.camelPlural,
    lifecycleHookImport: lifecycleHookImport(),
    ctxPlural: ctx.Plural,
    reorderContext: reorderContext,
    beforeHook: beforeHook('beforeReorder', 'lifecycleContext'),
    afterHook: afterHook('afterReorder', '{ ...lifecycleContext, data: { order: appliedOrder } }')
  })
}
